/** Page references are buttons, never model-supplied HTML or URLs. */
export function PdfCitedReply({
  text,
  pages,
  onPage,
}: {
  text: string;
  pages: number;
  onPage: (page: number) => void;
}) {
  return (
    <p className="whitespace-pre-wrap break-words text-sm leading-relaxed">
      {text.split(/(\[p\.\d+\])/g).map((part, i) => {
        const match = /^\[p\.(\d+)\]$/.exec(part);
        const page = Number(match?.[1]);
        return match && page >= 1 && page <= pages ? (
          <button
            key={i}
            type="button"
            onClick={() => onPage(page)}
            className="inline-flex min-h-11 items-center rounded-lg px-1 font-bold underline decoration-brand-sky underline-offset-4"
          >
            {part}
          </button>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </p>
  );
}
